var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    "data-name": "New Gradient Swatch 1",
    x1: 32.999,
    y1: 514.042,
    x2: 549.152,
    y2: -2.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#0bb1d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0bb1d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -4.521,
    y1: 476.521,
    x2: 511.631,
    y2: -39.631,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 21.479,
    y1: 502.521,
    x2: 537.631,
    y2: -13.631,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -68.521,
    y1: 412.521,
    x2: 447.631,
    y2: -103.631,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -106.521,
    y1: 374.521,
    x2: 409.631,
    y2: -141.631,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -80.521,
    y1: 400.521,
    x2: 435.631,
    y2: -115.631,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 13.979,
    y1: 495.021,
    x2: 530.131,
    y2: -21.131,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 85.979,
    y1: 567.021,
    x2: 602.131,
    y2: 50.869,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 33.479,
    y1: 514.521,
    x2: 549.631,
    y2: -1.631,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 51.479,
    y1: 532.521,
    x2: 567.631,
    y2: 16.369,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 55.479,
    y1: 536.521,
    x2: 571.631,
    y2: 20.369,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 81.479,
    y1: 562.521,
    x2: 597.631,
    y2: 46.369,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -184.521,
    y1: 296.521,
    x2: 331.631,
    y2: -219.631,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -148.521,
    y1: 332.521,
    x2: 367.631,
    y2: -183.631,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: -152.521,
    y1: 328.521,
    x2: 363.631,
    y2: -187.631,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 19.479,
    y1: 500.521,
    x2: 535.631,
    y2: -15.631,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: -36.521,
    y1: 444.521,
    x2: 479.631,
    y2: -71.631,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: -16.521,
    y1: 464.521,
    x2: 499.631,
    y2: -51.631,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 5.479,
    y1: 486.521,
    x2: 521.631,
    y2: -29.631,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472,128H419.84a207.772,207.772,0,0,0-327.68,0H40A32.036,32.036,0,0,0,8,160V400a32.036,32.036,0,0,0,32,32H204.9l-10.67,32H168a8,8,0,0,0-8,8v16H80a8,8,0,0,0,0,16H432a8,8,0,0,0,0-16H352V472a8,8,0,0,0-8-8H317.77L307.1,432H472a32.036,32.036,0,0,0,32-32V160A32.036,32.036,0,0,0,472,128ZM256,64c103.19,0,187.62,81.83,191.84,184H305.77l57.79-78.48a8,8,0,0,0-.78-10.4l-9.9-9.9a8,8,0,0,0-10.4-.78l-91.22,67.18a6.788,6.788,0,0,0-.9.79A40.086,40.086,0,0,0,216.8,248H64.16C68.38,145.83,152.81,64,256,64Zm16.72,155.68,73.71-54.28.17.17-54.28,73.71A40.178,40.178,0,0,0,272.72,219.68ZM278.63,248H233.37a24,24,0,0,1,45.26,0ZM336,480v8H176v-8ZM211.1,464l10.67-32h68.46l10.67,32ZM488,400a16.021,16.021,0,0,1-16,16H40a16.021,16.021,0,0,1-16-16V384H488Zm0-32H24V160a16.021,16.021,0,0,1,16-16H80.8A206.6,206.6,0,0,0,48.17,248H40a8,8,0,0,0,0,16H472a8,8,0,0,0,0-16h-8.17A206.6,206.6,0,0,0,431.2,144H472a16.021,16.021,0,0,1,16,16Z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,392H48a8,8,0,0,0,0,16H96a8,8,0,0,0,0-16Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,392h-8a8,8,0,0,0,0,16h8a8,8,0,0,0,0-16Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,104a8,8,0,0,0,8-8V80a8,8,0,0,0-16,0V96A8,8,0,0,0,256,104Z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.343,145.657a8,8,0,0,0,11.314-11.314l-12-12a8,8,0,1,0-11.314,11.314Z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,240H96a8,8,0,0,0,0-16H80a8,8,0,0,0,0,16Z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,148a7.976,7.976,0,0,0,5.657-2.343l12-12a8,8,0,1,0-11.314-11.314l-12,12A8,8,0,0,0,369,148Z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,240h16a8,8,0,0,0,0-16H413a8,8,0,0,0,0,16Z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,312H400a8,8,0,0,0,8-8V280a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v24A8,8,0,0,0,112,312Zm8-24H392v8H120Z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,320H160a8,8,0,0,0,0,16H352a8,8,0,0,0,0-16Z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,344H216a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,344h-8a8,8,0,0,0,0,16h8a8,8,0,0,0,0-16Z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,104A48,48,0,1,0,8,56,48.054,48.054,0,0,0,56,104ZM25.013,64H50.345L58.8,87.871c-.922.08-1.853.129-2.8.129A32.056,32.056,0,0,1,25.013,64ZM73.876,82.529,64.964,57.35,83.178,39.135a31.951,31.951,0,0,1-9.3,43.394ZM56,24a31.792,31.792,0,0,1,15.607,4.079L51.687,48H25.013A32.056,32.056,0,0,1,56,24Z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,24h96a8,8,0,0,0,0-16H120a8,8,0,0,0,0,16Z",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,48h32a8,8,0,0,0,0-16H120a8,8,0,0,0,0,16Z",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496,8H464a8,8,0,0,0-8,8V64a8,8,0,0,0,8,8h32a8,8,0,0,0,8-8V16A8,8,0,0,0,496,8Zm-8,48H472V24h16Z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,24h96a8,8,0,0,0,0-16H344a8,8,0,0,0,0,16Z",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,32H376a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,56H416a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16Z",
    fill: "url(#s)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.f1c0ac56f3ebbe026097581b96771eaf.svg";
export { ForwardRef as ReactComponent };